import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX, FiBookOpen } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import LanguageSwitcher from './LanguageSwitcher';

const NavbarRo = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Acasă', href: '/ro' },
    { name: 'Povestea', href: '/ro/story' },
    { name: 'Capitole', href: '/ro/chapters' },
    { name: 'Autor', href: '/ro/author' },
  ];

  const isActive = (href) => location.pathname === href || (href === '/ro' && location.pathname === '/ro/');

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-brand-dark/80 backdrop-blur-md border-b border-white/5 py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between">
        <Link to="/ro" className="flex items-center gap-2 group">
          <SafeIcon icon={FiBookOpen} className="text-brand-accent text-2xl group-hover:text-white transition-colors" />
          <span className="font-display font-bold text-lg tracking-wider text-white hidden sm:block">TREZIREA CUANTICĂ</span>
        </Link>

        <div className="hidden md:flex items-center space-x-6">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.href}
              className={`text-sm font-medium transition-colors ${isActive(link.href) ? 'text-brand-accent' : 'text-gray-300 hover:text-brand-accent'}`}
            >
              {link.name}
            </Link>
          ))}
          <LanguageSwitcher />
          <a
            href="https://www.amazon.com/dp/B0GXDZXVNV"
            target="_blank"
            rel="noreferrer"
            className="px-5 py-2 rounded-full bg-brand-accent text-brand-dark font-semibold text-sm hover:bg-brand-accentHover transition-colors duration-300"
          >
            Cumpără Cartea
          </a>
        </div>

        <button className="md:hidden text-gray-300 hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="text-2xl" />
        </button>
      </div>

      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="absolute top-full left-0 w-full bg-brand-dark border-b border-white/5 py-4 px-6 md:hidden flex flex-col space-y-4 shadow-xl"
          >
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                onClick={() => setMobileMenuOpen(false)}
                className={`font-medium text-lg ${isActive(link.href) ? 'text-brand-accent' : 'text-gray-300 hover:text-brand-accent'}`}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-2"><LanguageSwitcher /></div>
            <a
              href="https://www.amazon.com/dp/B0GXDZXVNV"
              target="_blank"
              rel="noreferrer"
              onClick={() => setMobileMenuOpen(false)}
              className="px-5 py-3 rounded-lg bg-brand-accent text-brand-dark font-semibold text-center mt-4"
            >
              Cumpără Cartea
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default NavbarRo;